module.exports = __webpack_public_path__ + "static/img/004-ban-2.1aea4e21.jpg";